export default {
    catalogos: [
        {
            text: 'Online Domicilio',
            value: 'online-domicilio'
        },
        {
            text: 'Online Recoger',
            value: 'online-recoger'
        },

        {
            text: 'TPV Mostrador',
            value: 'tpv-mostrador'
        },
        {
            text: 'TPV Recoger',
            value: 'tpv-recoger'
        },
        {
            text: 'TPV Domicilio',
            value: 'tpv-domicilio'
        },
        {
            text: 'TPV Mesa',
            value: 'tpv-mesa'
        },
        {
            text: 'Carta',
            value: 'carta'
        },

    ],
    productosCatalogos: [],
    categoriaFiltrar: null,
    generarCatalogo: true, //flag para saber si hay que generar catálogo
    //catalogos a generar
    generarCatalogoObj: {
        negocio: false,
        restaurantes: [],
        catalogos: [],
        productos: []
    },
    loadingGenerarCatalogos: false,
    generarAutomaticos: true,

}